import React from 'react';

import classNames from 'classnames';

import DeleteButton from '../DeleteButton';

import renderFieldGroup from '../helpers/renderFieldsGroup';

export default function ArrayField({
  form,
  fieldGroup,
  index,
  i,
  isSettingsForm,
  isVisible,
  tabindex,
  gridStyle,
  readOnly,
  groupSizeOffset,
  title,
  isSubmitting,
  disabled,
  submitButtonLabel,
  inlineSubmitButton,
  empty,
  isLast,
  isFirst,
  dragListItem,
  noteComponent: NoteComponent,
  noteComponentProps,
}) {
  const isArray = fieldGroup.type === 'array';
  const arrayFieldName = fieldGroup.name;

  const addArrayItem = () => {
    const initialValues = form.formik.initialValues[arrayFieldName][0];
    const newItemValues = {};

    Object.keys(initialValues).forEach((key) => {
      if (key === 'id') {
        newItemValues[key] = Math.random().toString();
      } else {
        newItemValues[key] = '';
      }
    });

    form.formik.setFieldValue(arrayFieldName, [
      ...form.formik.values[arrayFieldName],
      newItemValues,
    ]);
  };

  const deleteArrayItem = (idx) => {
    const newArray = form.formik.values[arrayFieldName].filter(
      (_, j) => j !== idx
    );

    form.formik.setFieldValue(arrayFieldName, newArray);
  };

  const isButtonDisabled = (values, idx, checker) => {
    if (checker && typeof checker === 'function') {
      return checker(values, idx);
    }
    return false;
  };

  return (
    <>
      {fieldGroup.title && !fieldGroup.isTitleHidden && isFirst && (
        <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold">
          {fieldGroup.title}
        </h2>
      )}
      {!empty && (
        <div
          className={classNames(
            'shadow-lg border border-slate-200 dark:border-slate-700 px-4 py-2',
            {
              'cursor-pointer': fieldGroup.isDraggable && !readOnly,
            }
          )}
        >
          {renderFieldGroup({
            fieldGroup: { ...fieldGroup, isTitleHidden: true },
            form,
            isVisible,
            tabindex,
            gridStyle,
            readOnly,
            inlineRight:
              !isButtonDisabled(
                form.formik.values[arrayFieldName],
                i,
                fieldGroup.isDeleteDisabled
              ) && !readOnly ? (
                <DeleteButton deleteArrayItem={() => deleteArrayItem(i)} />
              ) : null,
            inlineLeft:
              fieldGroup.isDraggable && !readOnly ? (
                <svg
                  className="w-3 h-3 fill-slate-300 dark:fill-slate-600"
                  viewBox="0 0 12 12"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 1h12v2H0V1Zm0 4h12v2H0V5Zm0 4h12v2H0V9Z"
                    fillRule="evenodd"
                  />
                </svg>
              ) : null,
            groupSizeOffset,
            title,
            isSubmitting,
            disabled,
            submitButtonLabel,
            inlineSubmitButton,
            index,
            isArray: true,
            innerIndex: i,
            arrayFieldName,
            isDraggable: fieldGroup.isDraggable,
            onDragStart: (event) => dragListItem(event, i),
            isSettingsForm,
          })}
          {NoteComponent && (
            <div className="mt-2">
              <NoteComponent {...noteComponentProps(i, form.formik?.values)} />
            </div>
          )}
        </div>
      )}
      {isArray &&
        !isButtonDisabled(
          form.formik.values[arrayFieldName],
          form.formik.values[arrayFieldName].length,
          form.fields[index].isAddDisabled
        ) &&
        isLast &&
        !readOnly && (
          <button
            onClick={addArrayItem}
            type="button"
            className="btn bg-indigo-500 hover:bg-indigo-600 text-white flex justify-center self-end"
          >
            <svg
              className="w-4 h-4 fill-current opacity-50 shrink-0"
              viewBox="0 0 16 16"
            >
              <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
            </svg>
            <span className="ml-2">Add</span>
          </button>
        )}
    </>
  );
}
